import { render, staticRenderFns } from "./Certificate.vue?vue&type=template&id=bfd066a2&scoped=true"
import script from "./Certificate.vue?vue&type=script&lang=js"
export * from "./Certificate.vue?vue&type=script&lang=js"
import style0 from "./Certificate.vue?vue&type=style&index=0&id=bfd066a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd066a2",
  null
  
)

export default component.exports